module.exports = __webpack_public_path__ + "media/images/lb/181-cd84969c4ab00b1fc82cc3d54233f5cf.svg";